module.exports = __webpack_public_path__ + "img/when-i-work-logo.ba64a380.svg";